<template>
  <div class="shop-menu-agent-mode-wall main">
    <div class="wrapper no-scrollbar">
      <div class="subtitle">
        <span @click="close">
          <i class="fa fa-chevron-left" style="margin: 0 4px" />
          {{ $t("Remove Item From Basket") }}
        </span>
      </div>

      <!-- <p class="key">{{ $t("Remove Item From Basket") }}</p> -->
      <div
        v-for="(o, i) in items"
        :key="i"
        class="notification is-white"
        @click="remove(o.item)"
      >
        <p>
          <span class="qty-left">{{ o.quantity }}</span>
          <span class="has-text-weight-medium">{{ itemName }}</span>
          <i
            class="far fa-trash-alt has-text-grey is-pulled-right"
            style="padding: 4px 2px"
          />
        </p>
        <div class="options">
          <p v-for="o in o.item.options" :key="o.item">
            <i class="option-menu"> •&nbsp;{{ optionMenuName(o) }} </i>
            <span v-if="o.option.quantity > 1">{{ o.option.quantity }} x</span>
            {{ optionItemName(o) }}
          </p>
          <p v-if="o.item.comment">
            <i class="far fa-comment option-menu" />
            <i class="has-text-link" style="margin-left: 0px">
              {{ o.item.comment }}
            </i>
          </p>
        </div>
      </div>
      <div style="margin-left: 4px; color: grey">
        <i>Click the item you want to remove</i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    basketItems: Array,
    itemForRemoval: Object,
    lang: String,
    agentModeData: Object, // if editing previously entered data
    business: Object, // transport workflow, should be array
    commerce: Object, // commerce workflow data obj
  },
  data() {
    return {};
  },
  computed: {
    // itemName() {
    //   return this.itemForRemoval.name; // or language version
    // },
    itemName() {
      var o = this.itemForRemoval;
      if (!o[this.lang]) return o.name;
      return o[this.lang].name;
    },
    items() {
      var o = this.itemForRemoval;
      return this.basketItems.filter((i) => i.item.id === o.id);
    },
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("close");
    },
    remove(o) {
      this.$emit("remove", o);
      this.close(); // or could add a done button if there were multiple that could be removed
    },
    submit() {
      // sounds("safe");
      this.log("start_agent_mode_commerce_order");
      // var msg = `🦄 Agent Mode started by ${this.$store.getters.getNameAndNumber} @ ${this.business.name}`;
      // this.sendSuperuserNotification(msg);
      var data = { payment: this.payment, mobile: this.parsePhone() };
      this.$emit("submit", data);
      this.close();
    },
    optionMenuName(o) {
      var menu = o.menu.name;
      if (o.menu[this.lang]) menu = o.menu[this.lang];
      return menu;
    },
    optionItemName(o) {
      var option = o.option.name;
      if (o.option[this.lang]) option = o.option[this.lang].name;
      return option;
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  width: 100vw;
  bottom: 0;
  height: 100vh;
  /* background-color: whitesmoke; */
  background-color: rgba(0, 0, 0, 0.562);
  z-index: 21;
  backdrop-filter: blur(2px);
  overflow: hidden;
}
.wrapper {
  position: absolute;
  bottom: 0;
  padding: 12px;
  padding-bottom: 20px;
  text-align: left;
  background-color: whitesmoke;
  overflow: auto;
  max-height: calc(100% - 80px);
  width: 100vw;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}
.subtitle {
  width: 100%;
  display: inline-block;
  /* color: white; */
  opacity: 0.9;
  font-weight: 450;
  /* margin-left: 10px; */
  margin-bottom: 10px;
  vertical-align: top;
  line-height: 35px;
}
img {
  display: inline-block;
  /* position: absolute; */
  /* left: 12px; */
  height: 35px;
  /* background-color: white; */
}
.notification {
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #bbb;
  width: 100%;
}
.amount {
  display: inline-block;
  width: 40px;
}
.key {
  font-weight: 550;
  color: rgba(47, 47, 47, 0.5);
  margin: 6px 0;
}

.details {
  margin: 10px 0;
}
.details p {
  line-height: 1.8em;
}
.choose-one {
  position: absolute;
  right: 10px;
  font-size: 0.85em;
  padding: 4px;
  margin-bottom: 8px;
  color: blue;
  background-color: rgb(255, 242, 0);
  border-radius: 4px;
}

.grey {
  font-weight: 600;
  color: rgb(151, 151, 151);
  font-size: 0.7em;
  margin-left: 6px;
  /* text-decoration: underline overline; */
}
.link {
  border-bottom: 1px #ccc dotted;
}
.buttons .button {
  margin-bottom: 14px;
}
.buttons .fa {
  font-size: 1.5em;
}
.buttons .button span {
  /* width: 100px; */
  margin-left: 12px;
  /* text-align: right; */
  font-weight: 550;
}
.optional {
  position: absolute;
  right: 18px;
  margin-top: 28px;
  /* left: 116px;
  margin-top: -5px; */
  font-size: 0.7em;
  font-weight: 500;
  color: rgba(47, 47, 47, 0.5);
  z-index: 2;
  background-color: rgba(255, 255, 255, 0.6);
  line-height: 1;
  padding: 2px;
  border-radius: 3px;
}

.change {
  float: right;
  font-weight: 500;
  font-size: 0.9em;
  line-height: 1.5;
  margin-top: 4px;
}

.qty-left {
  line-height: 1.2em;
  display: inline-block;
  padding: 0 4px;
  padding-top: 3px;
  /* margin-bottom: 2px; */
  border-radius: 3px;
  border: 1px solid #209cee;
  font-weight: 500;
  margin-right: 4px;
}
.options {
  padding: 2px 6px;
}
.option-menu {
  font-weight: 500;
  opacity: 0.5;
  font-size: 0.9em;
}
</style>